const UPSELL_SECTION_HANDLE = 'upsell-products';
const UPSELL_LIMIT = document.querySelector('.upsells_data')?.getAttribute('upsell_limit') || 4;
const MATCH_BY = document.querySelector('.upsells_data')?.getAttribute('matched_type') || 'vendor'; 

async function getCartData() {
  const res = await fetch('/cart.js');
  return res.json();
}

// progress bar js

const progressEl = document.querySelector('.get_from_here');


if (progressEl) {
  window.masseage_full = progressEl.getAttribute('data1');
  window.remaining_full = progressEl.getAttribute('data2').split(' - ');

  function updateProgressBar(cartTotal) {
    const progresbar = document.querySelector('.progress-bar');
    const goal = window.freeShippingGoal;
    const percentage = Math.min((cartTotal / goal) * 100, 100);

    const fill = document.querySelector('.progress-fill');
    const text = document.querySelector('.progress-text');

    if (fill) {
      fill.style.width = `${percentage}%`;
       console.log(fill);
    }

    if (text) {
      if (cartTotal >= goal) {
        text.textContent = window.masseage_full;
        progresbar.classList.add('completed');  
      } else {
        const remainingEuros = ((goal - cartTotal) / 100).toFixed(2); // convert cents → euros
        text.textContent = `${window.remaining_full[0]} €${remainingEuros} ${window.remaining_full[1]}`;
        progresbar.classList.remove('completed');
      }
    }
  }

  function fetchAndUpdateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateProgressBar(cart.total_price);
      });
  }
  fetchAndUpdateCart();
}

async function getUpsellSectionItems() {
  const res = await fetch(`/?sections=${UPSELL_SECTION_HANDLE}`);
  const json = await res.json();
  const html = json[UPSELL_SECTION_HANDLE];

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const container = tempDiv.querySelector('#upsell-products-section');
  if (!container) {
    console.warn('No #upsell-products-section found');
    return [];
  }
  console.log('getUpsellSectionItems');
  return Array.from(container.querySelectorAll('.cart_upsell_item'));
}

async function renderUpsellProducts() {
  const upsellContainer = document.querySelector('.cart-drawer__cross-sell-carousel');
  const cartUpsellItem = document.querySelector('.cart_upsell_items');
  if (!upsellContainer) return;

  cartUpsellItem.classList.add('loading');

  const cartData = await getCartData();

  if (!cartData.items || cartData.items.length === 0) {
    upsellContainer.innerHTML = '';
    cartUpsellItem.classList.add('hidden');
    cartUpsellItem.classList.remove('loading');
    return;
  }

  const cartProductIds = cartData.items.map(i => i.product_id);
  const cartVendors = cartData.items.map(i => i.vendor);
  const cartTypes = cartData.items.map(i => i.product_type);

  const allUpsellItems = await getUpsellSectionItems();

  let filteredItems = allUpsellItems.filter(item => {
    const productId = parseInt(item.dataset.productId, 10);
    const vendor = item.dataset.vendor;
    const type = item.dataset.productType;

    if (cartProductIds.includes(productId)) return false;

    if (MATCH_BY === 'vendor' && vendor) return cartVendors.includes(vendor);
    if (MATCH_BY === 'type' && type) return cartTypes.includes(type);

    return false;
  });

  filteredItems = filteredItems.slice(0, UPSELL_LIMIT);

  // If no products match → hide
  if (filteredItems.length === 0) {
    upsellContainer.innerHTML = '';
    cartUpsellItem.classList.add('hidden');
    cartUpsellItem.classList.remove('loading');
    return;
  }

  // Show container (remove hidden)
  cartUpsellItem.classList.remove('hidden');
  upsellContainer.innerHTML = '';

  // Append filtered items
  filteredItems.forEach(item => {
    const productId = item.dataset.productId;
    const vendor = item.dataset.vendor;
    const type = item.dataset.productType;

    const title = item.querySelector('p')?.innerText || '';
    const imgSrc = item.querySelector('img')?.src || '';
    const productUrl = item.querySelector('a')?.href || '#';
    const variantId = item.querySelector('button')?.dataset.id || '';
    const priceHTML = item.querySelector('.price-list')?.outerHTML || '';

    upsellContainer.insertAdjacentHTML(
      'beforeend',
      `
      <div class="product-cross-sell cart_upsell_item"
           data-product-id="${productId}"
           data-vendor="${vendor}"
           data-product-type="${type}">
        <div class="horizonatal_controller">
          <div class="image_container_upsell">
            <a href="${productUrl}">
              <img src="${imgSrc}" alt="${title}" class="constrained-image">
            </a>
          </div>
          <div class="v-stack justify-items-start text_controller">
            <div class="v-stack gap-0.5">
              <a href="${productUrl}" class="h7">${title}</a>
              ${priceHTML}
            </div>
            <div class="add_to_cart_options">
              <button type="submit" data-id="${variantId}" class="add-to-cart">Add to cart</button>
            </div>
          </div>
        </div>
      </div>`
    );
  });

  initCarousel();

  setTimeout(function() {
    cartUpsellItem.classList.remove('loading');
  }, 1000);
  if (progressEl) {
  fetchAndUpdateCart();
  console.log('renderUpsellProducts');
  }
}



function initCarousel() {
  const slidesContainer = document.querySelector(".cart-drawer__cross-sell-carousel");
  const slide = slidesContainer?.querySelector(".product-cross-sell");
  const prevButton = document.getElementById("slide-arrow-prev");
  const nextButton = document.getElementById("slide-arrow-next");

  if (!slidesContainer || !slide || !prevButton || !nextButton) return;

  function updateButtons() {
    const totalWidth = slidesContainer.scrollWidth;
    const visibleWidth = slidesContainer.clientWidth;
    const scrollLeft = slidesContainer.scrollLeft;
    prevButton.disabled = scrollLeft <= 0;
    nextButton.disabled = scrollLeft + visibleWidth >= totalWidth - 1;
  }

  prevButton.replaceWith(prevButton.cloneNode(true));
  nextButton.replaceWith(nextButton.cloneNode(true));

  const newPrev = document.getElementById("slide-arrow-prev");
  const newNext = document.getElementById("slide-arrow-next");

  newNext.addEventListener("click", () => {
    slidesContainer.scrollBy({ left: slide.clientWidth, behavior: 'smooth' });
    setTimeout(updateButtons, 100);
  });

  newPrev.addEventListener("click", () => {
    slidesContainer.scrollBy({ left: -slide.clientWidth, behavior: 'smooth' });
    setTimeout(updateButtons, 100);
  });

  slidesContainer.addEventListener("scroll", updateButtons);

  updateButtons();
  console.log('initCarousel');
}

function triggerCartUpdate() {
  const quantitySelectors = document.querySelectorAll(
    'table.cart-items__table quantity-selector-component.quantity-selector'
  );
  if (!quantitySelectors.length) return;

  const lastIndex = quantitySelectors.length - 1;
  const quantityComponent = quantitySelectors[lastIndex];
  const input = quantityComponent.querySelector('input[type="number"]');
  const currentQty = parseInt(input.value, 10) || 0;

  quantityComponent.dispatchEvent(new CustomEvent('quantity-selector:update', {
    detail: { quantity: currentQty, cartLine: lastIndex + 1 },
    bubbles: true
  }));
}

function addItemToCart(variantId, onComplete) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ quantity: 1, id: variantId })
  })
    .then(res => res.json())
    .then(() => {
      triggerCartUpdate();
      if (onComplete) onComplete();
    })
    .catch(err => {
      console.error('Add to cart failed:', err);
      if (onComplete) onComplete();
    });
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('.add_to_cart_options button');
  if (!button) return;
  addItemToCart(button.getAttribute('data-id'), () => {
    setTimeout(() => renderUpsellProducts(), 400);
  });
});

document.addEventListener('DOMContentLoaded', renderUpsellProducts);
document.addEventListener('cart:updated', renderUpsellProducts);
window.renderUpsellProducts = renderUpsellProducts;
window.initCarousel = initCarousel;